import React, { useState } from "react";
import { shape, string } from "prop-types";
import { generateNearlyUniqueID } from "common/uuid";
import actionLinkArrowImage from "../../../assets/images/instagram/action_link_arrow.svg";
import actionBarImage from "../../../assets/images/instagram/instagram_action_bar.png";
import replaceHtmlContent from "./helpers/replace-html-content";

const propTypes = {
  image: shape({
    image: string,
    type: string,
    mimeType: string
  }).isRequired,
  facebookPage: shape({
    name: string,
    picture: string
  }).isRequired,
  facebookNewsfeedData: shape({
    body: string,
    title: string,
    message: string,
    domain: string
  }).isRequired,
  width: string
};

const InstagramAdPreview = ({ image, facebookPage, facebookNewsfeedData, width = "270px" }) => {
  const uuid = generateNearlyUniqueID();
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <table
      title="instagram-ad-preview"
      cellSpacing="0"
      cellPadding="0"
      style={{
        width,
        borderWidth: "1px",
        borderColor: "#bcbcbc",
        borderStyle: "solid"
      }}
    >
      <tbody>
        <tr>
          <td width={width}>
            <table cellSpacing="0" cellPadding="0" width={width}>
              <tbody>
                <tr>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                  <td style={{ width: "32px", padding: "8px 0" }}>
                    {facebookPage.picture ? (
                      <img
                        src={facebookPage.picture}
                        style={{
                          width: "30px",
                          borderRadius: "100%",
                          borderWidth: "1px",
                          borderColor: "#e5e5e5",
                          borderStyle: "solid"
                        }}
                        alt={replaceHtmlContent(facebookPage.name)}
                      />
                    ) : (
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#CCCCCC",
                          color: "#999999",
                          fontSize: "24px",
                          lineHeight: "40px",
                          textAlign: "center",
                          borderRadius: "50%"
                        }}
                      >
                        ?
                      </div>
                    )}
                  </td>
                  <td
                    style={{
                      fontFamily: "Helvetica,Arial,sans-serif",
                      fontSize: "12px",
                      color: "#3A3A3A",
                      fontWeight: "bold",
                      lineHeight: "30px",
                      paddingLeft: "8px"
                    }}
                  >
                    {replaceHtmlContent(facebookPage.name)}
                  </td>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td width={width}>
            {image.mimeType === "text/html" ? (
              <iframe
                title="Preview your ad"
                alt={image.type}
                width={width}
                src={image.image}
                frameBorder="0"
                scrolling="no"
                data-testid="iframe"
              />
            ) : (
              <div style={{ minHeight: "200px", position: "relative" }}>
                <div style={{ zIndex: 2, height: "100%" }}>
                  <img src={image.image} alt={image.type} onLoad={() => setIsLoaded(true)} />
                </div>
                <div
                  id={`placeholder-${uuid}`}
                  className="ad-preview-placeholder"
                  style={{ display: isLoaded ? "none" : "block" }}
                />
              </div>
            )}
          </td>
        </tr>
        <tr>
          <td width={width}>
            <table cellSpacing="0" cellPadding="0" width={width}>
              <tbody>
                <tr>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                  <td
                    style={{
                      color: "#44ACF1",
                      fontFamily: "Helvetica,Arial,sans-serif",
                      fontSize: "13px",
                      padding: "8px 0",
                      fontWeight: "bold"
                    }}
                  >
                    Learn More
                  </td>
                  <td style={{ width: "12px" }}>
                    <img
                      src={actionLinkArrowImage}
                      style={{ height: "16px" }}
                      alt="action link arrow"
                    />
                  </td>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td width={width}>
            <table cellSpacing="0" cellPadding="0" width={width}>
              <tbody>
                <tr>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                  <td
                    style={{
                      borderTopWidth: "1px",
                      borderTopStyle: "solid",
                      borderTopColor: "#dddddd",
                      borderBottomWidth: "1px",
                      borderBottomStyle: "solid",
                      borderBottomColor: "#dddddd"
                    }}
                  >
                    <img src={actionBarImage} style={{ height: "35px" }} alt="action bar" />
                  </td>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td width={width}>
            <table cellSpacing="0" cellPadding="0" width={width}>
              <tbody>
                <tr>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                  <td
                    style={{
                      padding: "8px 0",
                      fontFamily: "Helvetica,Arial,sans-serif",
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#3A3A3A"
                    }}
                  >
                    {replaceHtmlContent(facebookNewsfeedData.body) || ""}
                  </td>
                  <td style={{ width: "12px" }}>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

InstagramAdPreview.propTypes = propTypes;

export default InstagramAdPreview;
